export default "__VITE_ASSET__P62gWfIX__"